import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppActionMenu from '../../../../components/AppActionMenu';

export default function ShiftMasterTable({
  records = [],
  isLoading = false,
  onArchive,
  onDelete,
  onResetFilters,
}) {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-12 text-center shadow-sm">
        <div className="flex flex-col items-center justify-center gap-3">
          <div className="h-8 w-8 animate-spin rounded-full border-3 border-primary border-t-transparent" />
          <p className="text-xs font-semibold text-on-surface-variant">Loading Shifts...</p>
        </div>
      </div>
    );
  }

  if (records.length === 0) {
    return (
      <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest p-12 text-center shadow-sm">
        <div className="flex flex-col items-center justify-center gap-3">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
            <span className="material-symbols-outlined text-3xl">schedule</span>
          </div>
          <h3 className="text-lg font-bold text-on-surface">No Shifts Found</h3>
          <p className="text-xs text-on-surface-variant max-w-md">
            There are no shift records matching your filter criteria.
          </p>
          {onResetFilters && (
            <button
              type="button"
              onClick={onResetFilters}
              className="mt-2 rounded-xl bg-primary px-5 py-2 text-xs font-bold text-on-primary shadow-sm hover:bg-primary/90 transition cursor-pointer"
            >
              Reset Filters
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-sm">
      <div className="overflow-x-auto">
        <table className="w-full min-w-[750px] text-left text-sm">
          <thead>
            <tr className="border-b border-outline-variant/20 bg-surface-container-low/60 text-xs font-bold uppercase tracking-[0.08em] text-on-surface-variant">
              <th className="px-5 py-3.5">Name</th>
              <th className="px-5 py-3.5">Alias</th>
              <th className="px-5 py-3.5">In time</th>
              <th className="px-5 py-3.5">Out Time</th>
              <th className="px-5 py-3.5">Shift Type</th>
              <th className="w-20 px-5 py-3.5 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-outline-variant/15">
            {records.map((item) => (
              <tr
                key={item.id}
                onClick={() => navigate(`/payroll/shift-master/entry?id=${item.id}`)}
                className="transition-colors hover:bg-surface-container-low/50 cursor-pointer group"
              >
                {/* Name */}
                <td className="px-5 py-3.5 font-bold text-on-surface group-hover:text-primary transition-colors">
                  {item.name}
                </td>

                {/* Alias */}
                <td className="px-5 py-3.5 text-xs text-on-surface-variant font-medium">
                  {item.alias || '-'}
                </td>

                {/* In time */}
                <td className="px-5 py-3.5 text-xs font-medium text-on-surface">
                  {item.inTime}
                </td>

                {/* Out Time */}
                <td className="px-5 py-3.5 text-xs font-medium text-on-surface">
                  {item.outTime}
                </td>

                {/* Shift Type */}
                <td className="px-5 py-3.5 text-xs font-medium text-on-surface">
                  <span className="inline-flex items-center rounded-md bg-surface-container-high px-2.5 py-1 text-xs font-semibold text-on-surface">
                    {item.shiftType}
                  </span>
                </td>

                {/* Actions */}
                <td
                  className="px-5 py-3.5 text-right"
                  onClick={(e) => e.stopPropagation()}
                >
                  <AppActionMenu
                    triggerLabel=""
                    triggerIcon="more_vert"
                    showChevron={false}
                    triggerClassName="rounded-lg p-1.5 text-outline-variant transition-colors hover:bg-surface-container-low hover:text-primary bg-transparent cursor-pointer"
                    items={[
                      { key: 'edit', label: 'Edit Shift', icon: 'edit' },
                      {
                        key: 'archive',
                        label: item.status === 'Inactive' ? 'Unarchive' : 'Archive',
                        icon: item.status === 'Inactive' ? 'unarchive' : 'archive',
                      },
                      { key: 'delete', label: 'Delete Shift', icon: 'delete', danger: true },
                    ]}
                    onSelect={(key) => {
                      if (key === 'edit') {
                        navigate(`/payroll/shift-master/entry?id=${item.id}`);
                      } else if (key === 'archive') {
                        onArchive?.(item.id, item.name, item.status);
                      } else if (key === 'delete') {
                        onDelete?.(item.id, item.name);
                      }
                    }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
